import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "address-box address-box-show"
};
const _hoisted_2 = {
  class: "address-show-item"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "收件人", -1);
const _hoisted_4 = {
  class: "info"
};
const _hoisted_5 = {
  class: "address-show-item"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "手机号", -1);
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = {
  class: "address-show-item"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "所在地区", -1);
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = {
  class: "address-show-item"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "详细地址", -1);
const _hoisted_13 = {
  class: "info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showInfo,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $options.showInfo = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("i", {
      class: "address-close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePicker && $options.closePicker(...args))
    }), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString($props.address_info.address_name), 1)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString($props.address_info.address_mobile), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString($props.address_info.province) + _toDisplayString($props.address_info.city) + _toDisplayString($props.address_info.county), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString($props.address_info.address), 1)])])]),
    _: 1
  }, 8, ["show"]);
}